export const environment = {
  production: true,
  apiBaseUrl: 'https://api-dev.appoint360.com/api/',
  apiBaseUrlSignalR: 'https://api-dev.appoint360.com/',
  successMessageLifeTime: 5000,
  warningMessageLifeTime: 5000,
  errorMessageLifeTime: 10000,
  PAYMENT_TIMEOUT_SECONDS: 11 * 60 ,// 11 minutes
  nextBillionApiKey: '397d43c0cd494363a436843c1b2f4b90'
};
